import { render } from "./CtxPagination.vue?vue&type=template&id=640dc7ee"
import script from "./CtxPagination.vue?vue&type=script&lang=js"
export * from "./CtxPagination.vue?vue&type=script&lang=js"

import "./CtxPagination.vue?vue&type=style&index=0&id=640dc7ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__